module.exports = __webpack_public_path__ + "static/media/features-split-image-01.9c682f10.png";